import { Box, Divider, Typography } from "@mui/material";
import React, { JSX, useState } from "react";
import { tl } from "../../../components/translate";
import Panel from "../../../components/Panel";
import OpdRegisterForm from "./OpdRegisterForm";
import { HMIS } from "../../../interfaces/HmisInterface";
import { clientFullNameWithPhoneSelector } from "../../../reducers/client";
import { InfoRow } from "../MulDarta/MulDartaInfoPanel";
import { Client } from "../../../interfaces/ClientInterface";
import ClientSelect from "./ClientSelect";

interface Props {
  mulDarta?: HMIS;
  onClose: () => void;
  nextOpdNumber: string;
}

const CreateEditOpdRegisterPanel = ({ onClose, mulDarta, nextOpdNumber }: Props): JSX.Element => {
  const [client, setClient] = useState<(Client & { mulDartaNumber: string }) | null>(null);
  return (
    <Panel
      onClose={onClose}
      titleJsx={
        <Box display="flex" justifyContent="space-between" width="100%" alignItems="center">
          <Typography variant="h5" component="p">
            {tl("hmis.opdRegister")}
          </Typography>
          <Typography variant="body2">HMIS 1.3</Typography>
        </Box>
      }
      contentStyle={{
        height: "calc(100vh - 100px)"
      }}
    >
      <Box>
        <Box mb={2}>
          <>
            {!mulDarta && <ClientSelect value={client} onChange={(value) => setClient(value)} />}
            {(mulDarta?.client || client) && (
              <Box mt={2}>
                <Typography gutterBottom variant="h6" component="p">
                  {clientFullNameWithPhoneSelector(mulDarta?.client || client)}
                </Typography>
                <InfoRow
                  label="Mul Darta Number"
                  value={mulDarta?.mulDartaNumber || client?.mulDartaNumber || ""}
                />
              </Box>
            )}
          </>
        </Box>
        <Divider variant="fullWidth" sx={{ mb: 2 }} />
        <OpdRegisterForm
          onClose={onClose}
          mulDartaId={mulDarta?.id || client?.mulDartaId}
          clientId={mulDarta?.clientId || client?.id}
          nextOpdNumber={nextOpdNumber}
        />
      </Box>
    </Panel>
  );
};

export default CreateEditOpdRegisterPanel;
